module.exports = __webpack_public_path__ + "static/media/gift.c19ac166.svg";